"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var PersonCard =
/*#__PURE__*/
function (_Card$makeDefaultCard) {
  babelHelpers.inherits(PersonCard, _Card$makeDefaultCard);

  function PersonCard() {
    babelHelpers.classCallCheck(this, PersonCard);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PersonCard).apply(this, arguments));
  }

  babelHelpers.createClass(PersonCard, [{
    key: "renderImage",
    value: function renderImage() {
      return _react.default.createElement("div", {
        className: "image"
      }, _react.default.createElement(_ProfileImageContainer.default, {
        className: "userProfilePhoto",
        noImageClassName: "initials",
        image: this.image,
        name: this.objectTitle
      }));
    }
  }, {
    key: "renderBottomContent",
    value: function renderBottomContent() {
      return null;
    }
  }]);
  return PersonCard;
}(_base.default.makeDefaultCardType('person', 'Person'));

exports.default = PersonCard;